// import {
//   keepPreviousData,
//   useQuery,
//   useQueryClient,
// } from "@tanstack/react-query";
// import React, { useState } from "react";
// import { lngDetect } from "../../../../helpers/lngDetect";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import { useDebounce } from "../../../../hooks/useDebounce";
// import { eventList } from "../../../../services/eventService";
// import dayjs from "dayjs";
// import { organizationTeamList } from "../../../../services/organizationService";
// import Image from "../../../../components/elements/Image";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import RatingStars from "../../../../components/common/RatingStars";
// import Button from "../../../../components/form/Button";
// import Tooltip from "../../../../components/elements/Tooltip";
// import { useClipboard } from "../../../../util/Flag";
// import EventItemLoader from "../../../../components/loader/EventItemLoader";
// import noDataImage from "../../../../assets/images/dance.svg";
// import NoData from "../../../../components/elements/Nodata";
// import { Link } from "react-router-dom";

// const PromotionEvents = () => {
//   const { lang } = useSelector((state) => state?.langProvider);
//   const { session } = useSelector((state) => state?.authProvider);
//   const [keyword, setKeyword] = useState("");
//   const search = useDebounce(keyword, 300);
//   const [filters, setFilters] = useState({
//     limit: 8,
//     page: 1,
//     sortQuery: "-createdAt",
//   });
//   const { copied, copy } = useClipboard();

//   const { data: promoterEventData, isLoading: promoterEventLoading } = useQuery(
//     {
//       queryKey: ["promoterEventData", filters, search],
//       queryFn: async () => {
//         const res = await organizationTeamList({
//           ...filters,
//           ...(search && { keyword: search }),
//           user: session?.user?._id,
//           type: "promoter-invitation",
//           status: "active",
//         });

//         if (res?.status !== 200) {
//           toast.warning(res?.message);
//         }
//         if (res?.docs?.status === 200) {
//           const new_data_arr = res?.docs?.data?.map((item) => {
//             const date = `${
//               item?.eventData?.startDate
//                 ? dayjs(item?.eventData?.startDate).format(
//                     item?.eventData?.endDate ? "DD" : "DD MMM YYYY"
//                   )
//                 : ""
//             }${
//               item?.eventData?.endDate
//                 ? " - " + dayjs(item?.eventData?.endDate).format("DD MMM YYYY")
//                 : ""
//             }`;

//             return {
//               ...item,
//               eventData: {
//                 id: item?.eventData?._id,
//                 uid: item?.eventData?.uid,
//                 eventTitle: lngDetect(item?.eventData?.title),
//                 eventDate: date || "",
//                 eventLocation: item?.eventData?.address?.name,
//                 eventMinRate: item?.eventData?.minTicketPrice || false,
//                 images: item?.eventData?.gallery?.map((img) => img?.url) || [],
//                 tags:
//                   item?.eventData?.tagData?.map((item) =>
//                     lngDetect(item?.eventData?.name)
//                   ) || [],
//                 link: `${window.location?.origin}/${lang}/event-details/${item?.eventData?.uid}?referral_code=${item?.uid}`,
//               },
//             };
//           });

//           if (search || filters.page === 1) {
//             return {
//               ...res?.docs,
//               data: [...new_data_arr],
//             };
//           } else {
//             return {
//               ...res?.docs,
//               data: [
//                 ...(promoterEventData?.data || []),
//                 ...new_data_arr,
//               ]?.filter(
//                 (item, index, self) =>
//                   index === self.findIndex((t) => t?._id === item?._id)
//               ),
//             };
//           }
//         } else {
//           return {
//             ...res,
//             data: [],
//           };
//         }
//       },
//       placeholderData: keepPreviousData,
//     }
//   );

//   const loadMore = () => {
//     if (promoterEventData?.metadata?.hasNextPage) {
//       setFilters((pre) => ({
//         ...pre,
//         page: promoterEventData?.metadata?.nextPage,
//       }));
//     }
//   };

//   return (
//     <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto relative space-y-10 py-10">
//       {promoterEventLoading && (
//         <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 2xl:gap-8">
//           {Array.from({ length: 8 }, (_, i) => (
//             <EventItemLoader key={i} />
//           ))}
//         </div>
//       )}
//       {!promoterEventLoading && promoterEventData?.data?.length > 0 && (
//         <div className="grid grid-cols-3 gap-3">
//           {promoterEventData?.data?.map((item, i) => (
//             <Link
//               key={i?.toString()}
//               to={`/${lang}/promotion-events-dashboard/${item?.uid}`}
//               className="flex border border-slate-100 rounded-lg overflow-hidden "
//             >
//               <div className="w-52 h-60">
//                 {item?.eventData?.images?.length > 0 ? (
//                   item.eventData?.images.length > 1 ? (
//                     <Swiper
//                       slidesPerView={1}
//                       autoplay={{
//                         delay: 2500,
//                         disableOnInteraction: false,
//                       }}
//                       pagination={{ clickable: true }}
//                       breakpoints={{
//                         320: { slidesPerView: 1 },
//                       }}
//                       modules={[Autoplay, Pagination]}
//                       className="w-full !h-full eventSlider"
//                     >
//                       {item.eventData?.images.map((img, index) => (
//                         <SwiperSlide key={index}>
//                           <div className="w-full h-full">
//                             <Image
//                               src={img}
//                               classes="object-cover object-center"
//                             />
//                           </div>
//                         </SwiperSlide>
//                       ))}
//                     </Swiper>
//                   ) : (
//                     <div className="w-full h-full">
//                       <Image
//                         src={item?.eventData?.images[0]}
//                         classes="object-cover object-center"
//                       />
//                     </div>
//                   )
//                 ) : (
//                   <div className="w-full h-full bg-slate-100"></div>
//                 )}
//               </div>
//               <div className="flex-1 p-3 max-w-[calc(100%-208px)]">
//                 {item?.eventData?.eventTitle && (
//                   <div className="text-base text-deep-purple font-bold line-clamp-2 mb-4 uppercase">
//                     {item?.eventData?.eventTitle}
//                   </div>
//                 )}

//                 {item?.eventData?.eventDate && (
//                   <div className="text-text-secondary text-xs font-medium mb-1 flex items-center gap-3">
//                     <span className="w-6 h-6 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0 border border-primary/10">
//                       <i className="fa-regular fa-calendar-days text-primary"></i>
//                     </span>{" "}
//                     {item?.eventData?.eventDate}
//                   </div>
//                 )}
//                 {item?.eventData?.eventLocation && (
//                   <div className="text-text-secondary text-xs font-medium mb-4 flex items-center gap-3">
//                     <span className="w-6 h-6 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0 border border-primary/10">
//                       <i className="fa-regular fa-location-dot text-primary"></i>
//                     </span>{" "}
//                     {item?.eventData?.eventLocation}
//                   </div>
//                 )}
//                 <div className="flex items-center gap-2">
//                   <div className="rounded-md py-2 px-2 h-9 text-center bg-primary/10 border border-primary text-sm font-medium flex-1 truncate">
//                     {item?.uid}
//                   </div>
//                   <div className="relative">
//                     <Tooltip
//                       messageClass={"!px-3 !py-2 !text-xm"}
//                       message={copied ? "Copied!" : "Copy"}
//                     >
//                       <Button
//                         buttonLabelClasses="text-deep-purple"
//                         buttonIcon="fa fa-copy"
//                         buttonIconPosition="left"
//                         buttonFunction={() => copy(item?.uid)}
//                         buttonClasses="bg-primary/10 text-primary px-0  px-2 border-primary rounded-md h-9"
//                       />
//                     </Tooltip>
//                   </div>
//                 </div>
//                 <div className="relative mt-2">
//                   <Tooltip
//                     messageClass={"!px-3 !py-2 !text-xm"}
//                     message={copied ? "Copied!" : item?.eventData?.link}
//                     className={"w-full"}
//                   >
//                     <Button
//                       buttonLabelClasses="text-deep-purple"
//                       buttonIcon="fa-solid fa-link"
//                       buttonIconPosition="left"
//                       buttonFunction={() => copy(item?.eventData?.link)}
//                       buttonClasses="bg-primary/10 text-primary px-0  px-2 border-primary rounded-md h-9 !w-full"
//                       buttonLabel={"Share URL"}
//                     />
//                   </Tooltip>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>
//       )}
//       {!promoterEventLoading && promoterEventData?.data?.length === 0 && (
//         <NoData
//           image={noDataImage}
//           message="Currently events are not available for promote"
//         />
//       )}
//     </div>
//   );
// };

// export default PromotionEvents;

import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import React, { useState } from "react";
import { lngDetect } from "../../../../helpers/lngDetect";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDebounce } from "../../../../hooks/useDebounce";
import { eventList } from "../../../../services/eventService";
import dayjs from "dayjs";
import { organizationTeamList } from "../../../../services/organizationService";
import Image from "../../../../components/elements/Image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import RatingStars from "../../../../components/common/RatingStars";
import Button from "../../../../components/form/Button";
import Tooltip from "../../../../components/elements/Tooltip";
import { ShareButtons, useClipboard } from "../../../../util/Flag";
import EventItemLoader from "../../../../components/loader/EventItemLoader";
import noDataImage from "../../../../assets/images/dance.svg";
import NoData from "../../../../components/elements/Nodata";
import { Link } from "react-router-dom";

const PromotionEvents = () => {
  const { lang } = useSelector((state) => state?.langProvider);
  const { session } = useSelector((state) => state?.authProvider);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [filters, setFilters] = useState({
    limit: 8,
    page: 1,
    sortQuery: "-createdAt",
  });
  const { copied, copy } = useClipboard();

  const { data: promoterEventData, isLoading: promoterEventLoading } = useQuery(
    {
      queryKey: ["promoterEventData", filters, search],
      queryFn: async () => {
        const res = await organizationTeamList({
          ...filters,
          ...(search && { keyword: search }),
          user: session?.user?._id,
          type: "promoter-invitation",
          status: "active",
        });

        if (res?.status !== 200) {
          toast.warning(res?.message);
        }
        if (res?.docs?.status === 200) {
          const new_data_arr = res?.docs?.data?.map((item) => {
            const date = `${
              item?.eventData?.startDate
                ? dayjs(item?.eventData?.startDate).format(
                    item?.eventData?.endDate ? "DD" : "DD MMM YYYY"
                  )
                : ""
            }${
              item?.eventData?.endDate
                ? " - " + dayjs(item?.eventData?.endDate).format("DD MMM YYYY")
                : ""
            }`;

            return {
              ...item,
              eventData: {
                id: item?.eventData?._id,
                uid: item?.eventData?.uid,
                eventTitle: lngDetect(item?.eventData?.title),
                eventDate: date || "",
                eventLocation: item?.eventData?.address?.name,
                eventMinRate: item?.eventData?.minTicketPrice || false,
                images: item?.eventData?.gallery?.map((img) => img?.url) || [],
                tags:
                  item?.eventData?.tagData?.map((item) =>
                    lngDetect(item?.eventData?.name)
                  ) || [],
                link: `${window.location?.origin}/${lang}/event-details/${item?.eventData?.uid}?referral_code=${item?.uid}`,
              },
            };
          });

          if (search || filters.page === 1) {
            return {
              ...res?.docs,
              data: [...new_data_arr],
            };
          } else {
            return {
              ...res?.docs,
              data: [
                ...(promoterEventData?.data || []),
                ...new_data_arr,
              ]?.filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t?._id === item?._id)
              ),
            };
          }
        } else {
          return {
            ...res,
            data: [],
          };
        }
      },
      placeholderData: keepPreviousData,
    }
  );

  const loadMore = () => {
    if (promoterEventData?.metadata?.hasNextPage) {
      setFilters((pre) => ({
        ...pre,
        page: promoterEventData?.metadata?.nextPage,
      }));
    }
  };

  const handleCopy = (text, e) => {
    e.stopPropagation();
    e.preventDefault();
    copy(text);
  };

  return (
    <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto relative space-y-10 py-10 px-5">
      {promoterEventLoading && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 2xl:gap-8">
          {Array.from({ length: 8 }, (_, i) => (
            <EventItemLoader key={i} />
          ))}
        </div>
      )}
      {!promoterEventLoading && promoterEventData?.data?.length > 0 && (
        <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-3">
          {promoterEventData?.data?.map((item, i) => (
            <div
              key={i?.toString()}
              className="flex border border-slate-100 rounded-lg overflow-hidden"
            >
              <Link
                to={`/${lang}/promotion-events-dashboard/${item?.uid}`}
                className="w-40 md:w-52 h-60 flex-shrink-0"
              >
                {item?.eventData?.images?.length > 0 ? (
                  item.eventData?.images.length > 1 ? (
                    <Swiper
                      slidesPerView={1}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                      pagination={{ clickable: true }}
                      breakpoints={{
                        320: { slidesPerView: 1 },
                      }}
                      modules={[Autoplay, Pagination]}
                      className="w-full !h-full eventSlider"
                    >
                      {item.eventData?.images.map((img, index) => (
                        <SwiperSlide key={index}>
                          <div className="w-full h-full">
                            <Image
                              src={img}
                              classes="object-cover object-center"
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <div className="w-full h-full">
                      <Image
                        src={item?.eventData?.images[0]}
                        classes="object-cover object-center"
                      />
                    </div>
                  )
                ) : (
                  <div className="w-full h-full bg-slate-100"></div>
                )}
              </Link>

              <div className="flex-1 p-3 pr-2 max-w-[calc(100%-160px)] md:max-w-[calc(100%-208px)]">
                <Link to={`/${lang}/promotion-events-dashboard/${item?.uid}`}>
                  {item?.eventData?.eventTitle && (
                    <div className="text-base text-deep-purple font-bold line-clamp-2 mb-4 uppercase hover:text-primary transition-colors">
                      {item?.eventData?.eventTitle}
                    </div>
                  )}
                </Link>

                {item?.eventData?.eventDate && (
                  <div className="text-text-secondary text-xs font-medium mb-1 flex items-center gap-3">
                    <span className="w-6 h-6 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0 border border-primary/10">
                      <i className="fa-regular fa-calendar-days text-primary"></i>
                    </span>{" "}
                    {item?.eventData?.eventDate}
                  </div>
                )}
                {item?.eventData?.eventLocation && (
                  <div className="text-text-secondary text-xs font-medium mb-4 flex items-center gap-3">
                    <span className="w-6 h-6 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0 border border-primary/10">
                      <i className="fa-regular fa-location-dot text-primary"></i>
                    </span>{" "}
                    {item?.eventData?.eventLocation}
                  </div>
                )}
                <div className="flex items-center gap-2">
                  <div className="rounded-md py-2 px-2 h-9 text-center bg-primary/10 border border-primary text-xs md:text-sm font-medium flex-1 truncate">
                    {item?.uid}
                  </div>
                  <div className="relative">
                    <Tooltip
                      messageClass={"!px-3 !py-2 !text-xm"}
                      message={copied ? "Copied!" : "Copy"}
                    >
                      <Button
                        buttonLabelClasses="text-deep-purple"
                        buttonIcon="fa fa-copy"
                        buttonIconPosition="left"
                        buttonFunction={(e) => handleCopy(item?.uid, e)}
                        buttonClasses="bg-primary/10 text-primary px-0 px-2 border-primary rounded-md h-9"
                      />
                    </Tooltip>
                  </div>
                </div>

                <div className="relative mt-2">
                  <ShareButtons
                    url={item?.eventData?.link}
                    text={`Check out this event: ${item?.eventData?.eventTitle}`}
                    buttonIcon="fa-solid fa-link"
                    buttonLabel="Share URL"
                    buttonClass="bg-primary/10 text-primary px-2 border-primary rounded-md h-9 !w-full"
                    buttonLabelClasses="text-deep-purple"
                    size="md"
                    showCopyLink={true}
                    showEmail={true}
                    showNativeShare={true}
                    title="Share Event"
                    subtitle="Share this event with others"
                    copySuccessMessage="Event link copied!"
                    className="w-full"
                    anchor="bottom start"
                    panelWidth="w-80"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {!promoterEventLoading && promoterEventData?.data?.length === 0 && (
        <NoData
          image={noDataImage}
          message="Currently events are not available for promote"
        />
      )}
    </div>
  );
};

export default PromotionEvents;
